import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'demooz-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    imports: [IonIcon, ReactiveFormsModule],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class DemoozTextareaComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'autocomplete', required : false}) autocomplete: boolean = false;
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    @ViewChild('demoozTextarea') demoozTextarea: ElementRef;
    
    initialHeight: number = 65;
    isRequired: boolean = false;
    
    updateValueSubscription: Subscription;
    updateStatusChange: Subscription;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.setHeightTextarea();
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        this.updateValueSubscription = this.formGroupDirective.form.controls[this.formName].valueChanges.subscribe(value => {            
           this.setHeightTextarea();
        });
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        }); 
    }
    
    ngOnDestroy() {       
        if(this.updateValueSubscription){
            this.updateValueSubscription.unsubscribe();
        }
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    focusInput(){
        this.demoozTextarea.nativeElement.focus();
    }
    
    setHeightTextarea(){        
        setTimeout(() => {
            this.demoozTextarea.nativeElement.style.height = 'auto';
            var newHeight = Math.max(this.initialHeight, this.demoozTextarea.nativeElement.scrollHeight);
            this.demoozTextarea.nativeElement.style.height = newHeight+'px';
        },0);  
    }
    
    clearInput(){
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){                               
                this.formGroupDirective.form.controls[this.formName].setValue('');
            }
        }
    }

}
